export default __webpack_public_path__ + "static/mcnair-20c002074f371f44d065f4bbd9490688.jpg";